<template>
  <div class="a2a_kit a2a_kit_size_24 a2a_default_style">
    <!-- Renderiza os botões dinamicamente -->
    <a v-for="btn in buttons"
       :key="btn.value"
       :class="`a2a_button_${btn.value}`"
       :title="btn.label">
    </a>
  </div>
</template>

<script>
export default {
  name: "SocialShare",
  props: {
    buttons: {
      type: Array,
      required: true
    },
    url: {
      type: String,
      default: () => window.location.href
    },
    title: {
      type: String,
      default: () => document.title
    }
  },
  mounted() {
    // Configuração inicial AddToAny
    window.a2a_config = window.a2a_config || {};
    window.a2a_config.linkurl = this.url;
    window.a2a_config.linkname = this.title;

    // Reinicia AddToAny (necessário quando renderizado via Vue)
    this.$nextTick(() => {
      if (window.a2a && window.a2a.init) {
        window.a2a.init('page');
      }
    });
  }
};
</script>

<style scoped>
/* Estilo opcional para animação */
.a2a_kit a {
  transition: transform 0.2s ease;
}
.a2a_kit a:hover {
  transform: scale(1.05);
}
</style>